var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "modal-body" }, [
      _c(
        "form",
        { staticClass: "m-form m-form--state", attrs: { action: "" } },
        [
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _c(
                "div",
                {
                  class: [
                    { "has-danger": _vm.errors.has("alias") },
                    _vm.show_main ? "col-lg-8" : "col-lg-12"
                  ]
                },
                [
                  _c("label", { attrs: { for: "alias" } }, [
                    _vm._v(
                      _vm._s(_vm._f("capitalize")(_vm._f("translate")("name")))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.zone.alias,
                        expression: "zone.alias"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|min:2|max:70|uniqueAlias",
                        expression: "'required|min:2|max:70|uniqueAlias'"
                      }
                    ],
                    ref: "alias",
                    staticClass: "form-control m-input",
                    attrs: {
                      type: "text",
                      id: "alias",
                      name: "alias",
                      placeholder: _vm._f("capitalize")(
                        _vm._f("translate")("enter_alias")
                      )
                    },
                    domProps: { value: _vm.zone.alias },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.zone, "alias", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("alias"),
                          expression: "errors.has('alias')"
                        }
                      ],
                      staticClass: "m-form__help m--font-danger"
                    },
                    [_vm._v(" " + _vm._s(_vm.errors.first("alias")) + " ")]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.show_main
                ? _c(
                    "div",
                    {
                      staticClass: "col-lg-4",
                      class: { "has-danger": _vm.errors.has("is_main") }
                    },
                    [
                      _c("label", { attrs: { for: "is_main" } }, [
                        _vm._v(
                          "¿" +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("translate")("works_main_area")
                              )
                            ) +
                            "?"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-radio-inline" }, [
                        _c(
                          "label",
                          { staticClass: "m-radio", attrs: { id: "yes" } },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zone.is_main,
                                  expression: "zone.is_main"
                                }
                              ],
                              attrs: { type: "radio", name: "yes" },
                              domProps: {
                                value: 1,
                                checked: _vm._q(_vm.zone.is_main, 1)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(_vm.zone, "is_main", 1)
                                }
                              }
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("yes")
                                  )
                                ) +
                                "\n                "
                            ),
                            _c("span")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "m-radio", attrs: { id: "no" } },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zone.is_main,
                                  expression: "zone.is_main"
                                }
                              ],
                              attrs: { type: "radio", name: "no" },
                              domProps: {
                                value: 0,
                                checked: _vm._q(_vm.zone.is_main, 0)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.$set(_vm.zone, "is_main", 0)
                                }
                              }
                            }),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("capitalize")(
                                    _vm._f("translate")("no")
                                  )
                                ) +
                                "\n                "
                            ),
                            _c("span")
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group m-form__group row" }, [
              _vm.zone.is_main === 0
                ? _c(
                    "div",
                    {
                      staticClass: "col-lg-8",
                      class: { "has-danger": _vm.errors.has("upper_zone") }
                    },
                    [
                      _c("label", { attrs: { for: "upper_zone" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("capitalize")(
                              _vm._f("translate")("upper_zone")
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zone.upper_zone,
                              expression: "zone.upper_zone"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "form-control": true,
                            error: _vm.errors.has("upper_zone")
                          },
                          attrs: { id: "upper_zone", name: "upper_zone" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.zone,
                                "upper_zone",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "0" } }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("capitalize")(
                                  _vm._f("translate")("select_an_option")
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.arrayZones, function(z, index) {
                            return _c(
                              "option",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.edit,
                                    expression: "!edit"
                                  }
                                ],
                                key: index,
                                domProps: { value: z.id }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(z.alias) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.zones_edit, function(z, index) {
                            return _c(
                              "option",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.edit,
                                    expression: "edit"
                                  }
                                ],
                                key: index,
                                domProps: { value: z.id }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(z.alias) +
                                    "\n              "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: { "has-danger": _vm.errors.has("anti_passback") }
                },
                [
                  _c("label", { attrs: { for: "anti_passback" } }, [
                    _vm._v(
                      "¿" +
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("works_antipassback")
                          )
                        ) +
                        "?"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-radio-inline" }, [
                    _c(
                      "label",
                      { staticClass: "m-radio", attrs: { id: "yes_passback" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zone.anti_passback,
                              expression: "zone.anti_passback"
                            }
                          ],
                          attrs: { type: "radio", name: "yes_passback" },
                          domProps: {
                            value: 1,
                            checked: _vm._q(_vm.zone.anti_passback, 1)
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.zone, "anti_passback", 1)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("yes"))
                            ) +
                            "\n                "
                        ),
                        _c("span")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "m-radio", attrs: { id: "no_passback" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zone.anti_passback,
                              expression: "zone.anti_passback"
                            }
                          ],
                          attrs: { type: "radio", name: "no_passback" },
                          domProps: {
                            value: 0,
                            checked: _vm._q(_vm.zone.anti_passback, 0)
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.zone, "anti_passback", 0)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("no"))
                            ) +
                            "\n                "
                        ),
                        _c("span")
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-lg-4",
                  class: { "has-danger": _vm.errors.has("is_access_area") }
                },
                [
                  _c("label", { attrs: { for: "is_access_area" } }, [
                    _vm._v(
                      "¿" +
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")("access_area")
                          )
                        ) +
                        "?"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-radio-inline" }, [
                    _c(
                      "label",
                      { staticClass: "m-radio", attrs: { id: "yes_area" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zone.is_access_area,
                              expression: "zone.is_access_area"
                            }
                          ],
                          attrs: { type: "radio", name: "yes_area" },
                          domProps: {
                            value: 1,
                            checked: _vm._q(_vm.zone.is_access_area, 1)
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.zone, "is_access_area", 1)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("yes"))
                            ) +
                            "\n                "
                        ),
                        _c("span")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "m-radio", attrs: { id: "not_area" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zone.is_access_area,
                              expression: "zone.is_access_area"
                            }
                          ],
                          attrs: { type: "radio", name: "not_area" },
                          domProps: {
                            value: 0,
                            checked: _vm._q(_vm.zone.is_access_area, 0)
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(_vm.zone, "is_access_area", 0)
                            }
                          }
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(_vm._f("translate")("no"))
                            ) +
                            "\n                "
                        ),
                        _c("span")
                      ]
                    )
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: {
            type: "button",
            "data-dismiss": _vm.openOutside ? "" : "modal",
            id: "btn-cancel-zone"
          },
          on: { click: _vm.resetForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("cancel"))) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.submitForm }
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("submit"))) +
              "\n    "
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66d3b925", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66d3b925","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/zone/New.vue
// module id = 314
// module chunks = 0 1 57 58 84